import axios from 'axios'

export interface TableSchemaColumnChange {
  name: string
  type?: string
  position?: number
}

export interface TableSchemaRename {
  expected: string
  actual: string
  confidence?: string
}

export interface TableSchemaTableResult {
  title: string
  table: string
  status: 'changed' | 'unchanged' | 'error'
  missing: TableSchemaColumnChange[]
  added: TableSchemaColumnChange[]
  caseChanges: Array<{expected: string; actual: string}>
  possibleRenames: TableSchemaRename[]
  error?: string
}

export interface TableSchemaCheckReport {
  runId: number
  triggerType: 'manual' | 'automatic'
  status: 'changes' | 'no_changes' | 'error'
  startedAt: string
  completedAt: string
  summary: {
    total: number
    unchanged: number
    changed: number
    errors: number
  }
  tables: TableSchemaTableResult[]
  notification: {
    sent: boolean
    recipients: number
    reason?: string | null
    error?: string | null
  }
}

export interface TableSchemaAlertSettings {
  contacts: string[]
  schedule: {
    cron: string
    time: string
    timezone: string
  }
  lastCheck: TableSchemaCheckReport | null
}

interface ApiResponse<T> {
  success: boolean
  data: T
  error?: string
}

export async function getTableSchemaAlertSettings(): Promise<TableSchemaAlertSettings> {
  const response = await axios.get<ApiResponse<TableSchemaAlertSettings>>(
    '/settings/compra-ai/table-schema-alerts'
  )

  if (!response.data.success) {
    throw new Error(response.data.error || 'Erro ao carregar alertas de tabelas')
  }

  return response.data.data
}

export async function saveTableSchemaAlertContacts(contacts: string[]): Promise<string[]> {
  const response = await axios.put<ApiResponse<string[]>>(
    '/settings/compra-ai/table-schema-alerts/contacts',
    {contacts}
  )

  if (!response.data.success) {
    throw new Error(response.data.error || 'Erro ao salvar números de alerta')
  }

  return response.data.data || []
}

export async function triggerTableSchemaCheck(): Promise<TableSchemaCheckReport> {
  const response = await axios.post<ApiResponse<TableSchemaCheckReport>>(
    '/settings/compra-ai/table-schema-alerts/check'
  )

  if (!response.data.success) {
    throw new Error(response.data.error || 'Erro ao verificar tabelas')
  }

  return response.data.data
}
